import { contentTypeJson } from "components/CommonLib/CommonLib";
import { HttpInstance } from "lib/HttpLib";

// ==================== GET ====================
// [GET] 수신 거부 목록 검색 조건 가져오기
export async function getUnsubsListSearchParams() {
  return await HttpInstance.get(process.env.REACT_APP_USER_SERVER + "/cs/sms/refuse/search_param", {
    params: {},
  });
}

// [GET] 수신 거부 목록 검색
export async function getUnsubsList(queryData) {
  const { page, searchParams } = queryData;
  const formData = new FormData();

  formData.append("page_num", page);
  formData.append("search_param", JSON.stringify(searchParams));

  return await HttpInstance.post(
    process.env.REACT_APP_USER_SERVER + "/cs/sms/refuse/search",
    formData,
    contentTypeJson,
  );
}
